import { h } from 'preact';
import styled from 'styled-components';
import type { ComponentChildren } from 'preact';

interface ToggleButtonProps {
	id?: string;
	checked?: boolean;
	onChange: any;
	callback?: (ev?: any) => void;
	children?: ComponentChildren;
}

const Container = styled.div`
	display: flex;
	justify-content: space-between;
`;

const ToggleWrapper = styled.label`
	position: relative;
	display: inline-block;
	width: 60px;
	height: 34px;
	outline: none;
`;

const Slider = styled.div`
	width: 53px;
	height: 30px;
	cursor: pointer;
	background-color: #ccc;
	-webkit-transition: 0.4s;
	transition: 0.4s;
	border-radius: 34px;

	input:checked + & {
		background-color: black;
	}

	input:checked + &:before {
		-webkit-transform: translateX(23px);
		-ms-transform: translateX(23px);
		transform: translateX(23px);
	}

	&:before {
		position: absolute;
		content: '';
		height: 20px;
		width: 20px;
		top: 5px;
		left: 5px;
		background-color: #ffffff;
		-webkit-transition: 0.4s;
		transition: 0.4s;
		border-radius: 50%;
	}
`;

export const ToggleButton = ({
	id,
	onChange,
	checked,
	callback = () => null,
	children,
}: ToggleButtonProps) => {
	const handleChange = (ev: any) => {
		callback(ev);
		onChange(ev);
	};

	return (
		<Container>
			{children}
			<ToggleWrapper className="switch" id={id}>
				<input
					type="checkbox"
					style={{ display: 'none' }}
					checked={checked}
					onChange={handleChange}
				/>
				<Slider />
			</ToggleWrapper>
		</Container>
	);
};
